<template>
  <div :class="c()">
    <answer-option
      v-for="option in options"
      v-bind="$attrs"
      :key="option.id"
      v-model="optionId"
      :html-value="String(option.id)"
      required
    >
      {{ option.text }}
    </answer-option>
  </div>
</template>

<script>
import {cn} from '@/app/js/classname'
import AnswerOption from '@/app/vue/survey/answer/answer-option.vue'

const c = cn('answer-options')
export default {
  name: 'AnswerOptions',
  components: {AnswerOption},
  inheritAttrs:false,
  props: {
    options: {
      type: Array,
      default: null
    }
  },
  emits: ['input'],
  data() {
    return {
      optionId: ''
    }
  },
  watch: {
    optionId() {
      const answer = this.options.find(item => item.id === this.optionId)
      this.$emit('input', answer.text)
    }
  },
  methods: {
    c
  }
}
</script>

<style lang="scss">
.answer-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>
